import React from 'react';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import { useIntl, defineMessages, FormattedMessage } from 'react-intl';
import * as firebase from 'firebase/app';
import { useSnackbar } from 'notistack';
import useFirebaseError from 'hooks/useFirebaseError';

const messages = defineMessages({
  emailSended: {
    id: 'EmailVerifiedPaper.emailSended',
    defaultMessage: '인증이 이메일이 전송되었습니다.',
    description: 'Email sended'
  }
});

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(3, 2)
    },
    buttonWrapper: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginTop: theme.spacing(2)
    }
  })
);

const EmailVerifiedPaper = () => {
  const classes = useStyles();
  const [loading, setLoading] = React.useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const intl = useIntl();
  const getErrorMesssage = useFirebaseError();

  async function sendEmail() {
    setLoading(true);
    const user = firebase.auth().currentUser;
    if (user) {
      try {
        await user.sendEmailVerification();
        setLoading(false);
        enqueueSnackbar(intl.formatMessage(messages.emailSended));
      } catch (error) {
        enqueueSnackbar(getErrorMesssage(error));
        setLoading(false);
      }
    }
  }

  return (
    <div>
      <Container maxWidth="sm">
        <Paper className={classes.root}>
          <Typography variant="h5" component="h3" gutterBottom>
            <FormattedMessage
              id="EmailVerifiedPaper.title"
              defaultMessage="이메일 인증"
              description="Verify email"
            />
          </Typography>
          <Typography component="p">
            <FormattedMessage
              id="EmailVerifiedPaper.content"
              defaultMessage="아직 인증이 완료되지 않았습니다. 원할한 서비스 사용을 위하여 이메일 인증을 해주세요."
              description="Verify email"
            />
          </Typography>
          <div className={classes.buttonWrapper}>
            <Button
              color="primary"
              variant="contained"
              onClick={sendEmail}
              disabled={loading}
            >
              <FormattedMessage
                id="EmailVerifiedPaper.button"
                defaultMessage="인증 메일 재전송"
                description="Verify email"
              />
            </Button>
          </div>
        </Paper>
      </Container>
    </div>
  );
};

export default EmailVerifiedPaper;
